var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"surface"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":['PrescriptionList']}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }